import { Component, OnInit, Input, Injectable, Inject, ViewChild, Output } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subject } from 'rxjs/Subject';
import { MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, Response } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { EnvironmentProvider } from '../../core/browser-providers';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { Environment } from '../../../environments/enviroment.model';
import { TranslateService } from '../../core/translate.service';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { MediaService } from '../../shared-services/media.service';
import { Subscription } from 'rxjs/Subscription';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { GenericListComponent, Page, HasAction, Actions } from '../../shared-components/generic-list/generic-list.component';
import { SecurityService } from '../../security/security.service';
import { Talle } from './talle.model';


interface Filters {
  description: string;
  page: number;
  size: number;
  sort: string;
  search?: string;
}

@Component({
  selector: 'app-talle-list',
  templateUrl: './talle-list.component.html',
  styleUrls: ['./talle-list.component.scss']
})
@Injectable()
export class TalleListComponent implements OnInit {

  // @Output() subtitle = 'Listado';

  private filters: Filters = {
    description: undefined,
    page: 0,
    size: 10,
    sort: 'orden'
  };

  columns = [
    { name: 'orden',  label: 'Orden' },
    { name: 'description',  label: 'Descripcion' }
  ];

  public showFilters = true;
  isMobile: boolean;

  @ViewChild(GenericListComponent)
  private genericListComponent: GenericListComponent;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  public hasActions: HasAction;

  filtersActive = false;
  mostrarResumen = false;
  isLoading = false;

  filtersLoaded = false;
  subscriptions: Subscription[] = [];

  itemsList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const tallesPromise = this.backendService.get(Talle, Talle.path, filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const talles = await tallesPromise;
        return talles;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.filtersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<Talle[]>;

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    private snackService: SnackService,
    private traslateService: TranslateService,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    private http: Http,
    public securityService: SecurityService,
    private dialogService: DialogService,
  ) { }

  ngOnInit() {
    this.showFilters = true;
    this.filtersLoaded = true;

    this.hasActions = new HasAction();

    this.hasActions.hasAction = true;
    this.hasActions.actions = [{ 'element': Actions.edit, 'permission': 'EDITAR_SUGERENCIA'},
                              { 'element': Actions.delete, 'permission': 'ELIMINAR_SUGERENCIA'}];

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.showFilters = !this.isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.itemsList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refreshItemsList();
  }


  refreshItemsList() {
    this.itemsList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      description : undefined,
      sort: 'orden',
      page: 0,
      size: 10,
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshItemsList();
  }

  onSearch(searchText) {
    this.filters.search = 'description:' + searchText;
    this.refreshItemsList();
  }

  clearSearch() {
      this.refreshItemsList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  displayFilters(boolean: boolean) {
    this.showFilters = boolean;
  }

  onAdd() {
    this.router.navigate(['/talles/agregar']);
  }


  onEdit(role: Talle) {
    this.router.navigate(['/talles/editar', role.id]);
  }


  async onDelete(talle: Talle) {

    this.dialogService.confirm('Eliminar talle',
    '¿Está seguro que desea eliminar el talle ' + talle.description + '?')
    .then( res => {
      if (res) {
        this.deleteSugerencia(res, talle);
      }
    });

  }

  async deleteSugerencia(res, talle: Talle) {

    if (res) {

      this.snackService.spinner(true);

      try {
        await this.backendService.delete(Talle.path + talle.id);
        this.snackService.success('Talles eliminados correctamente');
      } catch (ex) {
        this.snackService.error(ex.message);
      } finally {
        this.snackService.spinner(false);
        this.refreshItemsList();
      }

    }

  }

  onFiltersChanged(event) {
    this.refreshItemsList();
  }

  removeChip(event) {
    this.refreshItemsList();
  }

}



// WEBPACK FOOTER //
// ./src/app/productos/talle/talle-list.component.ts